import { render, staticRenderFns } from "./SliderTabs.vue?vue&type=template&id=7b9ca412&scoped=true&"
import script from "./SliderTabs.vue?vue&type=script&lang=js&"
export * from "./SliderTabs.vue?vue&type=script&lang=js&"
import style0 from "./SliderTabs.vue?vue&type=style&index=0&id=7b9ca412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ca412",
  null
  
)

export default component.exports